"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTag = exports.TagSize = exports.TagColor = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var FontAwesomeIcon_1 = require("../FontAwesomeIcon");
var TagIcon_1 = __importDefault(require("./TagIcon"));
exports.TagColor = [
    "warning",
    "success",
    "primary",
    "danger",
    "dark",
    "secondary"
];
exports.TagSize = ["md"];
var setColor = function (props) {
    var color = props.color, type = props.type, outline = props.outline;
    var activeColor = color || type;
    var getStyleColor = function () {
        switch (activeColor) {
            case "primary":
            case "success":
            case "warning":
            case "secondary":
                return style_utils_1.getColor(activeColor, 500);
            case "dark":
                return style_utils_1.getColor("gray", 900);
            case "danger":
                return style_utils_1.getColor("danger", 400);
            default:
                return style_utils_1.getColor("gray", 100);
        }
    };
    var gray0 = style_utils_1.getColor("gray", 0);
    var styleColor = getStyleColor();
    var ignoredColor = activeColor === "warning" || !exports.TagColor.find(function (c) { return c === activeColor; });
    var ignoreIconColor = (activeColor === "warning" && !outline) ||
        !exports.TagColor.find(function (c) { return c === activeColor; });
    return outline
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        border: 1px solid ", ";\n        background-color: ", ";\n        ", " {\n          color: ", ";\n        }\n      "], ["\n        color: ", ";\n        border: 1px solid ", ";\n        background-color: ", ";\n        ", " {\n          color: ", ";\n        }\n      "])), ignoredColor ? style_utils_1.getColor("gray", 900) : styleColor, styleColor, gray0, FontAwesomeIcon_1.StyledFontAwesomeIcon, ignoreIconColor ? style_utils_1.getColor("gray", 900) : styleColor) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: ", ";\n        border: 1px solid ", ";\n        background-color: ", ";\n        ", " {\n          color: ", ";\n        }\n      "], ["\n        color: ", ";\n        border: 1px solid ", ";\n        background-color: ", ";\n        ", " {\n          color: ", ";\n        }\n      "])), ignoredColor ? style_utils_1.getColor("gray", 900) : gray0, styleColor, styleColor, FontAwesomeIcon_1.StyledFontAwesomeIcon, ignoreIconColor ? style_utils_1.getColor("gray", 900) : gray0);
};
exports.StyledTag = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  height: 20px;\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 500;\n  border-radius: 16px;\n  padding: 0.215rem 0.4rem;\n  display: inline-flex;\n  align-items: center;\n  ", ";\n"], ["\n  box-sizing: border-box;\n  height: 20px;\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 500;\n  border-radius: 16px;\n  padding: 0.215rem 0.4rem;\n  display: inline-flex;\n  align-items: center;\n  ", ";\n"])), function (props) { return setColor(props); });
exports.StyledTag.defaultProps = {
    size: "md"
};
var Tag = function (_a) {
    var children = _a.children, iconClassName = _a.iconClassName, props = __rest(_a, ["children", "iconClassName"]);
    return (react_1.default.createElement(exports.StyledTag, __assign({}, props),
        children,
        iconClassName && react_1.default.createElement(TagIcon_1.default, { iconClassName: iconClassName })));
};
exports.default = Tag;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map